import { getFestivalsOnDate, getAvailableYears } from 'indian-festivals';

/**
 * Fixed-date cultural / international days not covered by indian-festivals.
 * Month is 1-based. These never change year to year.
 */
const FIXED_CULTURAL_DAYS = [
  { month: 1, date: 1, name: 'New Year', emoji: '🎉' },
  { month: 2, date: 14, name: "Valentine's Day", emoji: '💝' },
  { month: 3, date: 8, name: "Women's Day", emoji: '🌸' },
  { month: 5, date: 1, name: 'Labour Day', emoji: '👷' },
  { month: 10, date: 31, name: 'Halloween', emoji: '🎃' },
  { month: 12, date: 31, name: "New Year's Eve", emoji: '🎆' },
];

const getHolidayEmoji = (holidayName) => {
  const name = holidayName.toLowerCase();
  if (name.includes('diwali') || name.includes('deepavali') || name.includes('kali puja')) return '🪔';
  if (name.includes('holi') || name.includes('hola mohalla')) return '🌈';
  if (name.includes('christmas')) return '🎄';
  if (name.includes('new year')) return '🎉';
  if (name.includes('independence') || name.includes('republic')) return '🇮🇳';
  if (name.includes('dussehra') || name.includes('dasara') || name.includes('vijayadashami') || name.includes('durga')) return '🪔';
  if (name.includes('eid') || name.includes('ramzan') || name.includes('ramadan') || name.includes('muharram') || name.includes('milad')) return '🌙';
  if (name.includes('ganesh') || name.includes('ganesha')) return '🐘';
  if (name.includes('pongal') || name.includes('sankranti') || name.includes('baisakhi') || name.includes('bihu') || name.includes('lohri')) return '🌾';
  if (name.includes('raksha') || name.includes('rakhi')) return '🎀';
  if (name.includes('labour') || name.includes('labor') || name.includes('may day')) return '👷';
  if (name.includes('guru nanak') || name.includes('guru gobind')) return '🕉️';
  if (name.includes('janmashtami') || name.includes('shivratri') || name.includes('ram navami') || name.includes('hanuman')) return '🕉️';
  if (name.includes('valentine')) return '💝';
  if (name.includes('halloween')) return '🎃';
  if (name.includes("women")) return '🌸';
  if (name.includes('teacher')) return '👨‍🏫';
  if (name.includes('children')) return '🧒';
  if (name.includes('yoga')) return '🧘';
  if (name.includes('onam')) return '🌺';
  if (name.includes('easter') || name.includes('good friday')) return '✝️';
  if (name.includes('buddha')) return '🪷';
  if (name.includes('gandhi') || name.includes('unity')) return '🇮🇳';
  return '🎊';
};

const toDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const pickPrimaryFestival = (festivals) => {
  if (!festivals?.length) return null;
  return (
    festivals.find((f) => f.isPublicHoliday) ||
    festivals.find((f) => f.popularity?.includes('National')) ||
    festivals[0]
  );
};

const getFixedCulturalDay = (date) => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return FIXED_CULTURAL_DAYS.find((d) => d.month === month && d.date === day) || null;
};

/**
 * Returns the special day for a given date, or null if none.
 * Prefers indian-festivals (Diwali, Holi, Eid, national days, etc.),
 * then falls back to fixed cultural days (Valentine's, Halloween, ...).
 */
export const getSpecialDay = (date = new Date()) => {
  const year = date.getFullYear();
  const availableYears = getAvailableYears();

  if (availableYears.includes(year)) {
    const festivals = getFestivalsOnDate(toDateKey(date));
    const festival = pickPrimaryFestival(festivals);
    if (festival) {
      return {
        name: festival.name,
        emoji: getHolidayEmoji(festival.name),
        source: 'festival',
      };
    }
  }

  const culturalDay = getFixedCulturalDay(date);
  if (culturalDay) {
    return {
      name: culturalDay.name,
      emoji: culturalDay.emoji,
      source: 'cultural',
    };
  }

  return null;
};

export const formatSpecialDayWish = (specialDay) => {
  if (!specialDay) return null;
  const { emoji, name } = specialDay;
  return `${emoji} Happy ${name}! ${emoji}`;
};
